import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = { class: "text_btns" }
const _hoisted_3 = { class: "text_btns" }
const _hoisted_4 = { class: "text_btns" }
const _hoisted_5 = { class: "text_btns" }
const _hoisted_6 = { class: "text_btns" }
const _hoisted_7 = { style: {"width":"90px"} }

import { ref, computed, ComputedRef, onMounted, Ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import rangeComponent  from '@/components/SmartLink/dashboard/rangeComponent.vue';
import DialogComponent from '@/components/SmartLink/dialog/dialogComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import { useStore } from 'vuex';
import { TYPES, LABELS, VISIBLE_PAGES } from '@/constants/labels';
import { FINAL_HEADERS_TABLE } from '@/constants/tableHeaders';
import { FINAL_TYPE_LEGEND } from '@/constants/legends';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getAllLatencyData } from '@/services/Smartlink/KPI';
import { LATENCY } from '@/interfaces/SmartLink/Topology';
import { LEGEND } from '@/interfaces/SmartLink/General';



/**
 * Lista de todos los equipos, parte con la vista total, pero se pueden filtar
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'AllLatencyView',
  setup(__props) {

const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { smAndDown } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** CONSTANTES **********
 *******************************/
const finalTableItems:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos filtrados
 */
const arrayTodos:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con subtipo Acceso
 */
const arrayAcceso:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con subtipo Distribución
 */
const arrayDistri:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con subtipo Cliente
 */
const arrayClient:Ref<LATENCY[]> = ref([]);

/**
 * Lista de todos los equipos con estado Caído
 */
const arrayDowns:Ref<LATENCY[]>  = ref([]);

/**
 * Muestra el apartado de error, en vez de mostrar información o un espacio vacío. 
 * Generalmente es cuando desde la API no trae valores.
 */
const showError                         = ref(false);

/**
 * Mostrar los cards con info, si no tiene dato desde las API, oculta la tabla y los botones
 */
const showCard                          = ref(true);

/**
 * Mostrar el Loading
 */
const showCircle                        = ref(true);

async function getAllLatencies() {

     const allData = await getAllLatencyData()
        showError.value     = !allData.showGraphs;
        showCard.value      = allData.showGraphs;
        showCircle.value    = !allData.showGraphs;

        if( allData.status === 400 ){
            store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
        }
        if( allData.status === 200 ){
            arrayTodos.value    = allData.data.all 
            arrayDistri.value   = allData.data.distri 
            arrayAcceso.value   = allData.data.acceso 
            arrayClient.value   = allData.data.client 
            arrayDowns.value    = allData.data.downs 
        }

        finalTableItems.value = arrayTodos.value
}

/**
 * Muestra los valores en las tablas, dependiendo del tipo de Familia
 * También se aplica para todos los equipos y los equipos caídos
 * @param value Tipo de familia, todos o los caídos
 */
function changeData(value:string) {
    value === TYPES.all     ? finalTableItems.value = arrayTodos.value  : null;
    value === TYPES.distri  ? finalTableItems.value = arrayDistri.value : null;
    value === TYPES.acceso  ? finalTableItems.value = arrayAcceso.value : null;
    value === TYPES.client  ? finalTableItems.value = arrayClient.value : null;
    value === TYPES.down    ? finalTableItems.value = arrayDowns.value  : null;
}

/**
 * Mostrar el Dialogo
 */
 const dialog        = ref(false);

/**
 * IP del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedIp    = ref('');

/**
 * Nombre del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedName  = ref('');

/**
 * Tipo del equipo Seleccionado de la tabla para mostrar en el DIÁLOGO
 */
const selectedType  = ref('');

/**
 * Captura toda la información del elemento seleccionado en la tabla
 * y se almacenan los valores de (ip, tipo, nombre, marca, estado) en las variables correspondientes
 * para luego abrir el dialog con la información gráfica y estadística del equipo en cuestión
 * @param item La fila seleccionada en la tabla
 */
function showDialogWithType(item: LATENCY) {
    selectedIp.value        = item.ip;
    selectedName.value      = item.name;
    selectedType.value      = item.tipo;
    dialog.value            = true
}

/**
 * Cierra el Diálogo mediante un EMIT del componente de Dialogo
 */
function closeDialog (){
    dialog.value = false;
}

/**
 * Captura de la Constante el tipo de Cabecera de Tabla que tiene, dependiendo del valor de la vista seleccionada
 */
const headerLatency = FINAL_HEADERS_TABLE[VISIBLE_PAGES.latency];

/**
 * Valor de los HEADERS Seleccionados, solo que no se realiza aquí la petición por errores en el Front.
 * Una vez ya se hace el pedido a la API, recién se captura dicha cabecera de tabla
 */
const headertable   = ref(headerLatency);

/**
 * Captura de la Constante el tipo de Leyenda que tiene, dependiendo del valor de la vista seleccionada
 */
 const legend:ComputedRef<LEGEND[]>      = computed(() => FINAL_TYPE_LEGEND['latency']);

/**
 * Valor de la Legenda Seleccionada, solo que no se realiza aquí la petición por errores en el Front.
 * Una vez ya se hace el pedido a la API, recién se captura dicha leyenda
 */
const finalLegend                       = ref(legend.value);

onMounted(() => {
    getAllLatencies()  
})


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      class: "defaultCard",
      color: "bgtopology"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('title.allLatency')), 1),
        (showCard.value)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "ma-0 mr-2",
              justify: _unref(smAndDown) ? 'center' : 'end'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn_toggle, {
                  divided: "",
                  color: "#E84FC4",
                  rounded: "2",
                  group: "",
                  variant: "outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      class: "btnSlidersDashboard",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (changeData(_unref(TYPES).all)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('labels.all')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      class: "btnSlidersDashboard",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (changeData(_unref(TYPES).distri)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('labels.distribution')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      class: "btnSlidersDashboard",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeData(_unref(TYPES).client)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('labels.client')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      class: "btnSlidersDashboard",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (changeData(_unref(TYPES).acceso)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('labels.access')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      class: "btnSlidersDashboard",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (changeData(_unref(TYPES).down)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('labels.down')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["justify"]))
          : _createCommentVNode("", true),
        (finalTableItems.value.length > 0  && showCard.value)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              justify: "space-between",
              class: "ma-0 mb-4"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finalLegend.value, (item, i) => {
                  return (_openBlock(), _createBlock(_component_v_col, { key: i }, {
                    default: _withCtx(() => [
                      _createVNode(rangeComponent, {
                        "principal-color": item.prinColor ,
                        "secundary-color": item.secuColor ,
                        "color-text-princ": item.colorText1,
                        "color-text-secun": item.colorText2,
                        "principal-text": item.prinText,
                        "secundary-text": item.secuText
                      }, null, 8, ["principal-color", "secundary-color", "color-text-princ", "color-text-secun", "principal-text", "secundary-text"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (finalTableItems.value.length > 0  && showCard.value)
          ? (_openBlock(), _createBlock(_component_EasyDataTable, {
              key: 2,
              "header-text-direction": "left",
              "table-class-name": "customize-table",
              "show-index": "",
              headers: headertable.value,
              items: finalTableItems.value,
              "rows-per-page": 100,
              onClickRow: showDialogWithType
            }, {
              "item-ip": _withCtx((item) => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(item.ip), 1)
                ])
              ]),
              "item-latencia": _withCtx((item) => [
                _createVNode(_component_v_row, {
                  justify: "space-between",
                  style: {"align-items":"center !important"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "2",
                      class: "pa-0"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.latencia), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, {
                      cols: "10",
                      class: "pa-0 pr-6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_linear, {
                          style: {"border-radius":"20px"},
                          "model-value": 100,
                          height: "10",
                          striped: "",
                          color: 
                        item.latencia < 0 ? '#9E9E9E' : item.latencia <= 100 ? '#00FF00' : item.latencia <= 500 ? '#FFEE00' :'#FF0000'
                        }, null, 8, ["color"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["headers", "items"]))
          : _createCommentVNode("", true),
        (showCircle.value)
          ? (_openBlock(), _createBlock(_component_v_sheet, {
              key: 3,
              class: "text-center",
              color: "transparent"
            }, {
              default: _withCtx(() => [
                _createVNode(Prog_circular)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (showError.value)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 4,
              class: "ma-0 py-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_unref(t)('noInformation')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
      width: "85%"
    }, {
      default: _withCtx(() => [
        (dialog.value)
          ? (_openBlock(), _createBlock(DialogComponent, {
              key: 0,
              ip: selectedIp.value,
              typeSel: selectedType.value,
              name: selectedName.value,
              onDialog: closeDialog
            }, null, 8, ["ip", "typeSel", "name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})